var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wl-upload",
    _vm._b(
      {
        attrs: { "list-type": "picture-card" },
        model: {
          value: _vm.images,
          callback: function ($$v) {
            _vm.images = $$v
          },
          expression: "images",
        },
      },
      "wl-upload",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }